import InfoTwoToneIcon from "@mui/icons-material/InfoTwoTone";
import { Dialog, Grid, Tooltip, Typography, styled } from "@mui/material";
import React, { useContext } from "react";
import Chart from "react-apexcharts";
import { appLogger } from "../../utils";
import { UserLoginInfo } from "../../types/context";
import { UserContext } from "../../context/userContext";

const RatingGraph = (props: any) => {
  const {
    startupRatingData,
    freazeRatingData,
    layerRatingData,
    categoriesValue,
    ticketArrival,
    userDetails,
  } = props;
  appLogger.info({
    infoObj: {
      method: "RatingGraph",
      component: "dashboard",
      fileName: "RatingGraph.tsx",
      props: props,
    },
  });

  type datetime = "datetime";
  const chartType: datetime = "datetime";

  const series: any = [];
  const data: any = {
    options: {
      grid: {
        show: true,
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
      chart: {
        sparkline: {
          enabled: false,
        },
        height: 350,
        stacked: false,
        toolbar: {
          position: "top", // Adjust toolbar position
          export: {
            csv: {
              filename: "Rating_Analytics",
            },
            svg: {
              filename: "Rating_Analytics",
            },
            png: {
              filename: "Rating_Analytics",
            },
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        position: "top",
        horizontalAlign: "left",
        offsetX: 30,
        offsetY: 0,
        show: true,
        fontFamily: "Poppins",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "10px",
        labels: {
          useSeriesColors: true,
        },
        markers: {
          width: 10,
          height: 1,
        },
      },
      yaxis: {
        show: true,
        labels: {
          show: true,
          style: {
            colors: "#000000",
            width: "11px",
            height: "15px",
            fontFamily: "Poppins",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "10px",
          },
        },
      },
      xaxis: {
        type: chartType,
        labels: {
          // format: "HH:mm:ss MM-dd-yy",
          style: {
            colors: "#000000",
            width: "11px",
            height: "15px",
            fontFamily: "Poppins",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "10px",
          },
        },
        categories: categoriesValue,
        tooltip: {
          enabled: false,
        },
        axisBorder: { show: true },
        axisTicks: { show: false },
      },
      annotations: {
        xaxis: [
          {
            x: new Date(
              new Date(ticketArrival).getTime() -
                new Date(ticketArrival).getTimezoneOffset() * 60000
            ).getTime(),
            // x: new Date(ticketArrival).getTime(),
            strokeDashArray: 0,
            borderColor: "#FF8652",
            label: {
              borderColor: "#FF8652",
              style: {
                borderRadius: "4px",
                color: "white",
                // background: '#DBDCE0',
                width: "62px",
                height: "30px",
                background: "#FF8652",
              },
              orientation: "horizontal",
              text: `Ticket Arrival`,
            },
            mouseEnter: {
              custom: function (config: any) {
                return (
                  "<div>" +
                  "<h2 class='tooltip-title'>Time :<span>" +
                  ticketArrival +
                  "</span>" +
                  "</h2>" +
                  "<div>"
                );
              },
            },
          },
        ],
      },
      colors: ["#1fd351", "#fc6423", "#0157ff"],
      fill: {
        colors: ["#1fd351", "#fc6423", "#0157ff"],
      },
      tooltip: {
        custom: function (config: any) {
          return (
            `<div class="custom-tooltip" style="background: ${
              config.w.config.fill.colors[config.seriesIndex]
            }">` +
            "<h2 class='tooltip-title'>Rating :<span>" +
            config.w.globals.initialConfig.series[config.seriesIndex].name +
            "</span>" +
            "</h2>" +
            "<div class='tooltip-info'>" +
            config.series[config.seriesIndex][config.dataPointIndex] +
            // +
            // "<span>" +
            // `(${
            //   config.series[config.seriesIndex][config.dataPointIndex] > 0
            //     ? Math.floor(
            //         (config.series[config.seriesIndex][config.dataPointIndex] /
            //           config.w.globals.yRange[0]) *
            //           100
            //       )
            //     : 0
            // }%)` +
            // "</span>"
            "</div>" +
            "</div>"
          );
        },
        x: {
          format: "HH:mm:ss MM-dd-yyyy ",
        },
      },

      events: {
        click: function (event: any, chartContext: any, config: any) {
          appLogger.info({
            infoObj: {
              method: "RatingGraph",
              component: "dashboard",
              fileName: "RatingGraph.tsx",
              data: { event, chartContext, config },
            },
          });
          // The last parameter config contains additional information like `seriesIndex` and `dataPointIndex` for cartesian charts
        },
      },
      stroke: {
        show: true,
        // curve: "smooth",
        // lineCap: "butt",
        colors: undefined,
        width: 1,
        dashArray: 0,
      },
      markers: {
        size: [4, 4, 4],
      },
    },
  };
  freazeRatingData && freazeRatingData.length > 0
    ? series.push({
        name: "Freeze Frequency Rating",
        data: freazeRatingData,
      })
    : "";
  layerRatingData && layerRatingData.length > 0
    ? series.push({
        name: "Layer Rating",
        data: layerRatingData,
      })
    : "";
  startupRatingData && startupRatingData.length > 0
    ? series.push({
        name: "Startup Rating",
        data: startupRatingData,
      })
    : "";

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));

  return (
    <>
      {series.length > 0 ? (
        <Grid>
          <div>
            <Typography
              style={{
                color: "#202124",
                height: "27px",
                fontSize: "10px",
                textAlign: "right",
              }}
            >
              Ticket Arrival:{" "}
              {ticketArrival
                ? new Date(ticketArrival)
                    .toString()
                    .replace(
                      new Date(ticketArrival)
                        .toString()
                        .substring(
                          new Date(ticketArrival).toString().indexOf("GMT"),
                          new Date(ticketArrival).toString().length
                        ),
                      ""
                    )
                : ""}
            </Typography>
          </div>
          <div style={{ textAlign: "right" }}>
            <Tooltip
              title={
                <Grid container>
                  <Grid>
                    Startup Rating: It is based on the startup time. Takes too
                    long to startup. Very good (10): startup time {"<"}= 2,5
                    seconds, Very bad (0): startup time {">"}=10 seconds
                  </Grid>
                  <br></br>
                  <Grid>
                    Layer Rating: Player plays with bad quality. It is based on
                    the average bitrate. Very good (10): average bitrate {">"}=
                    3000000bps, Very bad (0): average bitrate {"<"}= 300000bps
                  </Grid>
                  <br></br>
                  <Grid>
                    Freeze Frequency Rating: It represents the number of seconds
                    between 2 freezes during the session. Very good (10): 1
                    freeze or less every 30 minutes, Very bad (0): 1 freeze or
                    more every 100 seconds
                  </Grid>
                </Grid>
              }
              placement="bottom"
            >
              <InfoTwoToneIcon
                color="primary"
                sx={{ mx: 1, fontSize: "20px" }}
              />
            </Tooltip>
          </div>
          <Chart
            options={data.options}
            series={series}
            type="line"
            height={320}
          />
        </Grid>
      ) : (
        ""
      )}

      {series.length == 0 && (
        <Typography className="no-data">no data</Typography>
      )}
    </>
  );
};

export default RatingGraph;
